var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"img"})]),_c('div',{staticClass:"description"},[_c('div',{staticClass:"line line-1"}),_c('div',{staticClass:"line line-3"}),_c('div',{staticClass:"line line-1"})])])
}]

export { render, staticRenderFns }